module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup"
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "disabled": _vm.disabled,
      "value": _vm.displayValue,
      "placeholder": _vm.$tx('暂无数据')
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.showLookupDialog
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('rt-lookup-multiple-dialog', {
    ref: "lookupDialog",
    attrs: {
      "lookup-title": _vm.lookupTitle,
      "entity": _vm.entity,
      "request-url": _vm.dialogRequestUrl,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "custom-conditions": _vm.dialogCustomConditions,
      "filter-fields": _vm.dialogFilterFields,
      "return-fields": _vm.dialogReturnFields,
      "multiple": _vm.multiple,
      "placeholder": _vm.placeholder
    },
    on: {
      "data-selected": _vm.handleDataSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507c3291"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/lookup/src/lookup-multiple.vue
// module id = 1499
// module chunks = 91